<template>
    <div :class="['form-group', size, disactive == true ? 'd-none' : '']">
        <label :for="name">{{ label }}</label>
        <select v-bind:class="'custom-select ' + (errors !== null ? 'error-input' : '')" :name="name" :value="modelValue" :placeholder="placeholder" @input="updateValue($event.target.value)" maxlength="150">
            <option disabled selected value>Wybierz...</option>
            <option v-for="(val, index) in values" :value="index" v-html="val" v-bind:selected="index == value" :key="val"></option>
        </select>
        <div class="error" v-if="errors">
            <ul>
                <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
        </div>
        <small class="form-text text-muted" v-if="extraInfo" v-html="extraInfo"></small>
    </div>
</template>

<script>
export default {
    props: ['label', 'values', 'name', 'placeholder', 'size', 'disactive', 'errorMessages', 'extraInfo', 'modelValue'],

    methods: {
        updateValue(value) {
            this.$emit('input', value);
            if(this.errorMessages && this.name in this.errorMessages) {
                this.value = value;
            }
        }
    },
    data() {
        return {
            value: ''
        };
    },
    computed: {
        errors: function () {
            if(this.errorMessages && this.name in this.errorMessages && this.value === '') {
                return this.errorMessages[this.name];
            }

            return null;
        }
    },
    watch: {
        errorMessages: function(newValue, oldValue) {
            this.value = '';
        }
    }
}
</script>
